export default __webpack_public_path__ + "3468ffb4c3417f0810519f957766ae99.svg";